import Weather from "./Weather.js";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Perth" />
      </div>
    </div>
  );
}

export default App;
